import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Router from './components/router/router';
import { ChakraProvider } from '@chakra-ui/react';
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
        <ChakraProvider>
            <Router />
        </ChakraProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
